var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCotiza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00095B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cotiza",
    transform: "translate(21492.756 23010.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    className: "st0",
    d: "M-21482.8-22990.3c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10c0,2.7-1.1,5.2-2.9,7.1 C-21477.6-22991.3-21480.1-22990.3-21482.8-22990.3z M-21482.8-23008.8c-4.7,0-8.6,3.8-8.6,8.6c0,4.7,3.8,8.6,8.6,8.6 c4.7,0,8.6-3.8,8.6-8.6c0-2.3-0.9-4.5-2.5-6.1C-21478.3-23007.9-21480.5-23008.8-21482.8-23008.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    className: "st0",
    d: "M-21482.7-23003.4c0.7,0,1.4,0.1,2.1,0.3c0.4,0.1,0.8-0.1,0.9-0.5c0.1-0.4-0.1-0.8-0.5-0.9 c-0.6-0.1-1.2-0.2-1.7-0.3v-1c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0,0,0v1c-1.9,0.3-2.2,1.6-2.2,2.2 c0,1.5,1.5,2.1,2.5,2.5l0.2,0.1l0.3,0.1c0.9,0.4,1.3,0.6,1.3,1.3c0,0.7-0.5,1-1.3,1h-0.2c-0.8-0.1-1.6-0.3-2.4-0.6 c-0.4-0.2-0.8,0-0.9,0.4s0,0.8,0.4,0.9c0,0,0,0,0,0c0.8,0.3,1.5,0.5,2.3,0.6v1c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1 c1.2-0.1,2.1-1.2,2.1-2.4c0-1.7-1.4-2.3-2.2-2.6l-0.4-0.2c-0.7-0.3-1.6-0.6-1.6-1.2 C-21484.1-23002.8-21484.1-23003.4-21482.7-23003.4L-21482.7-23003.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotiza);
export default __webpack_public_path__ + "static/media/cotiza.d6bc9e70e768dbd864229427d630c8f8.svg";
export { ForwardRef as ReactComponent };